import { useMutation, useQueryClient } from "@tanstack/react-query";
import SharedRecordAPI from "../../api/SharedRecordAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

export interface UpdateSharedPayload {
  Sync?: boolean;
}

interface Props {
  recordID: string;
  payload: UpdateSharedPayload;
  onSuccess?: () => void;
  onError: (err: string) => void;
}

// For updating shared records
// Currently used for:
// - Updating Sync option (true / false)
export default function useUpdateSharedRecord() {
  const client = useQueryClient();

  const updateSharedRecord = useMutation({
    mutationFn: ({ recordID, payload }: Props) =>
      SharedRecordAPI.updateSharedRecord(recordID, payload).then(
        (data) => data.data.data.record
      ),
    onSuccess: (record, { recordID, onSuccess }) => {
      client.setQueryData(["userSharedRecord", recordID], (prev: any) => {
        if (!prev) return { record, expired: true };

        return { ...prev, record };
      });

      callFunctionIfExists(onSuccess);
    },
    onError: (err, { onError }) => {
      onError(getErrorMessage(err));
    },
  });

  return {
    updateSharedRecord: updateSharedRecord.mutate,
    updatingShared: updateSharedRecord.isPending,
  };
}
